import { createStyles, Theme } from "@material-ui/core";

export const styles = ({spacing, breakpoints}: Theme) => createStyles({
    row: {
        borderBottom: "1px solid rgba(0,0,0,0.2)"
    },
    cell: {
        border: 0,
        fontWeight: 500,
        [breakpoints.up(1024)]: {
            whiteSpace: "nowrap"
        }
    },
    cellIcon: {
        marginRight: spacing.unit
    },
    cellLink: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        cursor: "pointer",
        whiteSpace: "nowrap"
    }
});


// WEBPACK FOOTER //
// ./src/components/CustomerTable/CustomerTable.style.tsx